import { type ParentComponent } from 'solid-js';
import { A } from '@solidjs/router';
import { t } from '@/shared/i18n';
import { usePublicPath } from '@/shared/lib/usePublicPath';
import MarketingNavbar from './components/MarketingNavbar';

const PublicLayout: ParentComponent = (props) => {
  const pp = usePublicPath();
  return (
    <div class="flex min-h-screen flex-col bg-white text-gray-900">
      <MarketingNavbar lightTheme />

      {/* Content */}
      <main class="flex-1">{props.children}</main>

      {/* Footer */}
      <footer class="border-t border-border-default bg-bg-surface">
        <div class="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
          <div class="flex flex-col items-center justify-between gap-4 sm:flex-row">
            <p class="text-sm text-text-secondary">
              {t('public.footer.copyright')}
            </p>
            <div class="flex gap-6">
              <A
                href={pp('/privacy')}
                class="text-sm text-text-secondary hover:text-text-primary"
              >
                {t('public.footer.privacy')}
              </A>
              <A
                href={pp('/terms')}
                class="text-sm text-text-secondary hover:text-text-primary"
              >
                {t('public.footer.terms')}
              </A>
              <A
                href={pp('/billing-terms')}
                class="text-sm text-text-secondary hover:text-text-primary"
              >
                {t('public.footer.billingTerms')}
              </A>
              <a
                href="mailto:human.khoai@gmail.com"
                class="text-sm text-text-secondary hover:text-text-primary"
              >
                {t('public.footer.contact')}
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PublicLayout;
